import React from 'react';
import { Lock, ArrowRight, CheckCircle2 } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';
import { toast } from 'sonner';

export const SubscriptionExpiredPage = () => {
    const { company, logout } = useAuth();

    const handleSignOut = async () => {
        try {
            await logout();
            window.location.href = '/login';
        } catch (error) {
            toast.error('Erro ao sair da conta');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-[#0A0A0A] flex flex-col items-center justify-center p-4">
            <div className="w-full max-w-lg bg-white dark:bg-[#111111] rounded-3xl shadow-2xl overflow-hidden border border-gray-100 dark:border-white/5">
                <div className="p-8 text-center border-b border-gray-100 dark:border-white/5 bg-red-50/50 dark:bg-red-900/10">
                    <div className="w-20 h-20 bg-red-100 dark:bg-red-900/30 rounded-2xl flex items-center justify-center mx-auto mb-6 transform -rotate-6">
                        <Lock className="w-10 h-10 text-red-500" />
                    </div>
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Acesso Bloqueado</h1>
                    <p className="text-gray-500 dark:text-gray-400 text-sm">
                        Sua assinatura do plano <strong className="uppercase text-gray-700 dark:text-gray-200">{company?.subscription_plan || 'Sistema'}</strong> expirou ou está inativa.
                    </p>
                </div>

                <div className="p-8 space-y-6">
                    <div className="bg-gray-50 dark:bg-white/5 rounded-2xl p-5 border border-gray-100 dark:border-white/5">
                        <h3 className="font-semibold text-gray-900 dark:text-white mb-3 text-sm">O que você ganha renovando agora:</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-300">
                                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                                Acesso imediato a todos os seus Leads e Funis
                            </li>
                            <li className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-300">
                                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                                Histórico completo de vendas mantido em segurança
                            </li>
                            <li className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-300">
                                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                                Automações e playbooks liberados novamente
                            </li>
                        </ul>
                    </div>

                    <div className="space-y-3 pt-2">
                        <a 
                            href="https://pay.kiwify.com.br/YOUR_KIWIFY_LINK_HERE" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl py-4 font-semibold text-sm hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg shadow-blue-500/25"
                        >
                            Renovar Assinatura <ArrowRight size={18} />
                        </a>
                        <button 
                            onClick={handleSignOut}
                            className="w-full py-3 text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white transition-colors"
                        >
                            Sair da conta
                        </button>
                    </div>
                </div>
            </div>
            
            <p className="mt-8 text-sm text-gray-500 dark:text-gray-400 max-w-sm text-center">
                Caso já tenha realizado o pagamento via Pix ou Cartão, o sistema liberará seu acesso em até 5 minutos automaticamente.
            </p>
        </div>
    );
};
